import { Dropdown } from 'tailwindcss-stimulus-components'

export default class MobileDropdown extends Dropdown {
  static targets = ["menu", "button"]
  static values = { open: Boolean, default: false }

  // Store the scroll position
  scrollPosition = 0

  connect() {
    super.connect()
    // Add event listeners to all menu items
    this.addMenuItemListeners()
  }

  // Add listeners to menu items
  addMenuItemListeners() {
    // Find all links within the menu
    const menuLinks = this.menuTarget?.querySelectorAll('a') || []

    // Add a click event to each link to close the dropdown
    menuLinks.forEach(link => {
      link.addEventListener('click', () => this.hideDropdown())
    })
  }

  // Override the original controller's openValueChanged method
  openValueChanged() {
    // Call the original method first
    super.openValueChanged()

    // If the dropdown is open, position it correctly
    if (this.openValue) {
      // Try to use the positioning method only if we have the necessary targets
      if (this.hasButtonTarget && this.hasMenuTarget) {
        this.positionDropdown()
      }
      this.blockScroll()
    } else {
      this.unblockScroll()
    }
  }

  // Position the dropdown below the button
  positionDropdown() {
    // Only try to position if we have the necessary elements
    if (!this.hasButtonTarget || !this.hasMenuTarget) {
      return
    }

    try {
      // Get the button's dimensions and position
      const buttonRect = this.buttonTarget.getBoundingClientRect()

      // Calculate the optimal position (just below the button)
      // For position: fixed, the top position is relative to the viewport
      const topPosition = buttonRect.bottom

      // Apply the position to the dropdown
      this.menuTarget.style.top = `${topPosition}px`
    } catch (error) {
      console.error('Error positioning dropdown:', error)
    }
  }

  // Method to close the dropdown
  hideDropdown() {
    this.openValue = false
  }

  // Simple method to block scrolling
  blockScroll() {
    this.scrollPosition = window.pageYOffset

    // Double approach to block scrolling
    // 1. Direct CSS styles
    document.body.style.overflow = 'hidden'
    document.body.style.position = 'fixed'
    document.body.style.top = `-${this.scrollPosition}px`
    document.body.style.width = '100%'

    // 2. CSS class as a backup
    document.body.classList.add('body-scroll-lock')
  }

  // Simple method to unblock scrolling
  unblockScroll() {
    // Remove the styles
    document.body.style.overflow = ''
    document.body.style.position = ''
    document.body.style.top = ''
    document.body.style.width = ''

    // Remove CSS class
    document.body.classList.remove('body-scroll-lock')

    window.scrollTo(0, this.scrollPosition)
  }
}
